import { Pencil } from "lucide-react"

import { Table, TableBody, TableCell, TableRow } from "@/components/ui/Table"

import { AssignmentFormData } from "../types"

interface ReviewStepProps {
  formData: AssignmentFormData
  onEdit: (step: number) => void
}

export function ReviewStep({ formData, onEdit }: ReviewStepProps) {
  return (
    <div className="tw-text-center tw-space-y-4">
      <h2 className="tw-text-3xl tw-font-bold tw-text-gray-800">
        Verify your choices
      </h2>

      <div className="tw-max-w-3xl tw-mx-auto tw-bg-white tw-rounded-xl tw-shadow-sm tw-overflow-hidden tw-border tw-border-gray-200">
        <div className="tw-max-h-[250px] tw-overflow-y-auto">
          <Table>
            <TableBody>
              <ReviewRow
                label="Summary:"
                value={formData.practiceTopic}
                onEdit={() => onEdit(1)}
              />
              <ReviewRow
                label="Grade:"
                value={formData.grade}
                onEdit={() => onEdit(2)}
              />
              <ReviewRow
                label="Class Time:"
                value={formData.classTime}
                onEdit={() => onEdit(3)}
              />
              <ReviewRow
                label="Curriculum:"
                value={formData.curriculum}
                onEdit={() => onEdit(4)}
              />
              <ReviewRow
                label="Practice Type:"
                value={formData.practiceType}
                onEdit={() => onEdit(5)}
              />
              <ReviewRow
                label="Additional Info:"
                value={formData.additionalConsiderations}
                onEdit={() => onEdit(6)}
              />
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  )
}

interface ReviewRowProps {
  label: string
  value: string | string[]
  onEdit: () => void
}

function ReviewRow({ label, value, onEdit }: ReviewRowProps) {
  // Format the display value
  const displayValue = Array.isArray(value)
    ? value.length > 0
      ? value.join(", ")
      : "Not specified"
    : value || "Not specified"

  return (
    <TableRow>
      <TableCell className="tw-text-left tw-text-sm tw-font-medium tw-text-gray-500 tw-w-32 tw-border-r tw-border-gray-200">
        {label}
      </TableCell>
      <TableCell className="tw-text-left tw-text-base tw-text-gray-900">
        {Array.isArray(value) && value.length > 1 ? (
          <div className="tw-flex tw-flex-wrap tw-gap-2">
            {value.map((item, index) => (
              <span
                key={index}
                className="tw-px-2 tw-py-1 tw-bg-gray-100 tw-text-gray-900 tw-rounded-md tw-text-sm"
              >
                {item}
              </span>
            ))}
          </div>
        ) : (
          displayValue
        )}
      </TableCell>
      <TableCell className="tw-text-right tw-w-16">
        <button
          type="button"
          onClick={onEdit}
          className="tw-text-gray-400 hover:tw-text-gray-600 tw-transition-colors"
          aria-label={`Edit ${label}`}
        >
          <Pencil className="tw-w-5 tw-h-5" />
        </button>
      </TableCell>
    </TableRow>
  )
}
